// extracted by mini-css-extract-plugin
export default {"sortSelector":"CaseDocumentSearchMobile_sortSelector__hlCFv","overflow":"CaseDocumentSearchMobile_overflow__9g8T9","spinner":"CaseDocumentSearchMobile_spinner__eGFQl"};